import React from "react";
import './loader3.css'
import image from "../images/logo_atlas.png"

export default function Loader3(){
    return(
<>
<img src={image} alt="Logo" className="loader-img" />
  <div className="wave"></div>
  <div className="wave"></div>
</>
    )
}